// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn {
    padding-left: 3rem;
    padding-right: 3rem;
}

.btn-outline-primary {
    border: 1px solid #dbc700;
    color: black;
    background: transparent;
}

.btn-outline-primary:hover,
.btn-outline-primary:active {
    background: #dbc700;
    color: white;
}

.header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

label {
    font-weight: bold;
}

.require-label:after {
    content: ' *';
    color: red;
}

.close {
}

.content-header {
    font-style: normal;
    font-weight: 600;
    font-size: 1.2rem;
    line-height: 27px;
    padding: 19px 0px 14px 0px;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbmZpcm0tZGVsZXRlLXRlYW0uY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLGtCQUFrQjtJQUNsQixtQkFBbUI7QUFDdkI7O0FBRUE7SUFDSSx5QkFBeUI7SUFDekIsWUFBWTtJQUNaLHVCQUF1QjtBQUMzQjs7QUFFQTs7SUFFSSxtQkFBbUI7SUFDbkIsWUFBWTtBQUNoQjs7QUFFQTtJQUNJLGFBQWE7SUFDYixtQkFBbUI7SUFDbkIsOEJBQThCO0FBQ2xDOztBQUVBO0lBQ0ksaUJBQWlCO0FBQ3JCOztBQUVBO0lBQ0ksYUFBYTtJQUNiLFVBQVU7QUFDZDs7QUFFQTtBQUNBOztBQUVBO0lBQ0ksa0JBQWtCO0lBQ2xCLGdCQUFnQjtJQUNoQixpQkFBaUI7SUFDakIsaUJBQWlCO0lBQ2pCLDBCQUEwQjtBQUM5QiIsImZpbGUiOiJjb25maXJtLWRlbGV0ZS10ZWFtLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuYnRuIHtcbiAgICBwYWRkaW5nLWxlZnQ6IDNyZW07XG4gICAgcGFkZGluZy1yaWdodDogM3JlbTtcbn1cblxuLmJ0bi1vdXRsaW5lLXByaW1hcnkge1xuICAgIGJvcmRlcjogMXB4IHNvbGlkICNkYmM3MDA7XG4gICAgY29sb3I6IGJsYWNrO1xuICAgIGJhY2tncm91bmQ6IHRyYW5zcGFyZW50O1xufVxuXG4uYnRuLW91dGxpbmUtcHJpbWFyeTpob3Zlcixcbi5idG4tb3V0bGluZS1wcmltYXJ5OmFjdGl2ZSB7XG4gICAgYmFja2dyb3VuZDogI2RiYzcwMDtcbiAgICBjb2xvcjogd2hpdGU7XG59XG5cbi5oZWFkZXItY29udGVudCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2Vlbjtcbn1cblxubGFiZWwge1xuICAgIGZvbnQtd2VpZ2h0OiBib2xkO1xufVxuXG4ucmVxdWlyZS1sYWJlbDphZnRlciB7XG4gICAgY29udGVudDogJyAqJztcbiAgICBjb2xvcjogcmVkO1xufVxuXG4uY2xvc2Uge1xufVxuXG4uY29udGVudC1oZWFkZXIge1xuICAgIGZvbnQtc3R5bGU6IG5vcm1hbDtcbiAgICBmb250LXdlaWdodDogNjAwO1xuICAgIGZvbnQtc2l6ZTogMS4ycmVtO1xuICAgIGxpbmUtaGVpZ2h0OiAyN3B4O1xuICAgIHBhZGRpbmc6IDE5cHggMHB4IDE0cHggMHB4O1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/all-modules/team/components/confirm-delete-team/confirm-delete-team.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;;IAEI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;AACA;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA,wgDAAwgD","sourcesContent":[".btn {\n    padding-left: 3rem;\n    padding-right: 3rem;\n}\n\n.btn-outline-primary {\n    border: 1px solid #dbc700;\n    color: black;\n    background: transparent;\n}\n\n.btn-outline-primary:hover,\n.btn-outline-primary:active {\n    background: #dbc700;\n    color: white;\n}\n\n.header-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\nlabel {\n    font-weight: bold;\n}\n\n.require-label:after {\n    content: ' *';\n    color: red;\n}\n\n.close {\n}\n\n.content-header {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 1.2rem;\n    line-height: 27px;\n    padding: 19px 0px 14px 0px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
